import React, { FC } from "react";
import { Image } from "../image";
import type { EndUserAppsHeroProps } from "@/types";
import { TextCols } from "../text-cols";

export const EndUserAppsHero: FC<EndUserAppsHeroProps> = ({
  label,
  title,
  description,
  cover,
}) => {
  return (
    <section className="endUserAppsHero">
      <div className="wrapper">
        <TextCols
          headingLevel="h1"
          size="lg"
          label={label}
          content={{
            title,
            textCol1: description.textCol1,
            textCol2: description.textCol2,
          }}
        />
      </div>
      <div className="wrapper wrapper_lg">
        {cover.file?.url && (
          <Image
            loading="eager"
            fetchPriority="high"
            className="endUserAppsHero--cover"
            src={cover as any}
            alt={cover.title}
            animateInView
          />
        )}
      </div>
    </section>
  );
};
